<template>
    <section class="tab-pane">
      <!-- Metadados -->
      <section class="tab-section">
        <h4>{{ t('relatorio_info_titulo') }}</h4>
        <section class="metadata-container">
          <article class="metadata-item">
            <span class="metadata-label">{{ t('scenery') }}:</span>
            <span class="metadata-value">
              {{ metadata.scenario?.scenarioId || t('relatorio_sem_nome') }}
            </span>
          </article>
          <article class="metadata-item">
            <span class="metadata-label">{{ t('relatorio_periodo') }}:</span>
            <span class="metadata-value">
              {{ formatScenarioPeriod(metadata.scenario?.period, t) }}
            </span>
          </article>
          <article class="metadata-item">
            <span class="metadata-label">{{ t('generated_in') }}</span>
            <span class="metadata-value">{{ formatDateTime(metadata.analysisMetadata?.generatedAt) }}</span>
          </article>
        </section>
      </section>
  
      <!-- Score -->
      <section class="tab-section">
        <h4>{{ t('relatorio_score_titulo') }}</h4>
        <section class="score-container">
          <template v-if="showScoreComparison">
            <div class="score-before-block">
              <div class="score-label-context">{{ t('before_IA') }}</div>
              <div class="score-circle-before" :class="getScoreClass(scoreBeforeAI)">
                <div class="score-value">{{ scoreBeforeAI }}</div>
                <div class="score-label">{{ t('relatorio_pontos') }}</div>
              </div>
              <div class="score-before-subtitle">{{ t('original_menu') }}</div>
            </div>
            <div class="score-arrow-block">
              <span class="score-arrow">→</span>
              <span class="score-delta">+{{ scoreDelta }} pts</span>
            </div>
          </template>
          <div class="score-circle" :class="getScoreClass(summary.overallScore)">
            <div class="score-value">{{ summary.overallScore }}</div>
            <div class="score-label">{{ t('relatorio_pontos') }}</div>
          </div>
          <section class="score-details">
            <header class="quality-level">
              <span class="quality-label">{{ t('relatorio_nivel_qualidade') }}:</span>
              <span
                class="quality-value"
                :class="getDictionary(summary.qualityLevel, 'qualityLevel', 'class')"
              >
                {{ getDictionary(summary.qualityLevel, 'qualityLevel') }}
              </span>
              <span v-if="showIAnotImprove" class="report-status-badge deprecated">
                {{ t('not_improved_by_IA') }}
              </span>
              <button
                v-if="showScoreComparison || showSolverChanges"
                type="button"
                class="clear-highlights-btn"
                @click="$emit('highlight-solver')"
              >
                {{ t('highlight_IA_improvements') }}
              </button>
              <button
                v-if="showScoreComparison || showSolverChanges"
                type="button"
                class="clear-highlights-btn"
                @click="$emit('clear-highlights-request')"
              >
                {{ t('relatorio_limpar_destaques') }}
              </button>
            </header>
            <div class="summary-text">
              {{ summary.summaryText }}
            </div>
          </section>
        </section>
      </section>
  
      <!-- Problemas -->
      <section class="tab-section">
        <h4>{{ t('relatorio_problemas_titulo') }}</h4>
        <section class="issues-summary">
          <article class="issue-count critical">
            <div class="issue-count-number">{{ summary.criticalIssuesCount || 0 }}</div>
            <div class="issue-count-label">{{ t('relatorio_criticos') }}</div>
          </article>
          <article class="issue-count medium">
            <div class="issue-count-number">{{ summary.mediumIssuesCount || 0 }}</div>
            <div class="issue-count-label">{{ t('relatorio_medios') }}</div>
          </article>
          <article class="issue-count low">
            <div class="issue-count-number">{{ summary.lowIssuesCount || 0 }}</div>
            <div class="issue-count-label">{{ t('relatorio_baixos') }}</div>
          </article>
        </section>
      </section>
    </section>
  </template>
  
  <script>
  import {
    formatScenarioPeriod,
    formatDateTime,
    getScoreClass,
    getDictionary
  } from './relatorioIA.js';
  
  export default {
    name: 'RelatorioSummaryTab',
    props: {
      summary: { type: Object, required: true },
      metadata: { type: Object, required: true },
      scoreBeforeAI: { type: Number, default: 0 },
      showScoreComparison: { type: Boolean, default: false },
      showSolverChanges: { type: Boolean, default: false },
      showIAnotImprove: { type: Boolean, default: false },
      isReportDeprecated: { type: Boolean, default: false }
    },
    computed: {
      scoreDelta() {
        return this.summary.overallScore - this.scoreBeforeAI;
      }
    },
    methods: {
      t(key, params) {
        return this.$t(key, params);
      },
      formatScenarioPeriod,
      formatDateTime,
      getScoreClass,
      getDictionary
    }
  };
  </script>
  
  <style scoped lang="less">
  </style>